import { useEffect } from 'react';

/**
 * An invalid drawer is open but no longer has the content it needs, such as
 * when its user, group, unit, or device disappears after a data refresh, or
 * when an action drawer has no selected entities. Close it after rendering to
 * avoid updating React state from inside a drawer's render helper.
 */
export const useCloseInvalidDrawer = (
  open: boolean,
  hasContent: boolean,
  setOpen: (open: boolean) => void,
) => {
  useEffect(() => {
    if (open && !hasContent) {
      setOpen(false);
    }
  }, [hasContent, open, setOpen]);
};
